var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart__error"},[_vm._t("default",function(){return [_c('img',{attrs:{"src":require("@/assets/error.png")}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.error))])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }